module.exports = __webpack_public_path__ + "img/arubab.60a71d72.jpg";